<!--!     LEILÃO VIRTUAL / TRANSMISSÂO -->
<app-live-bid-action
  *ngIf="
    loading === 0 &&
    bid_type === 'VIRTUAL' &&
    opened_schedule.enable_site_virtual
  "
  [animal_obj]="opened_schedule.transaction?.animal"
  [auction_bid]="opened_schedule.transaction?.auction_bid"
  [opened_schedule]="opened_schedule"
  [is_live]="is_live"
  [bid_status]="bid_status"
  [list_bids]="opened_schedule.transaction?.waiting_bids || []"
  [increment]="opened_schedule.increment || 20"
  [attual_bid]="attual_bid"
  [next_bid]="next_bid"
  [isStatus]="isStatus"
  (eventSocket)="eventSocket($event)"
></app-live-bid-action>

<!--?     LEILÃO AO VIVO / ON LINE -->
<app-online-bid-action
  *ngIf="
    loading === 0 &&
    bid_type === 'AOVIVO' &&
    opened_schedule.enable_site_real_time
  "
  [animal_obj]="opened_schedule.transaction?.animal || animal_obj"
  [auction_bid]="opened_schedule.transaction?.auction_bid"
  [opened_schedule]="opened_schedule"
  [is_live]="is_live"
  [bid_status]="bid_status"
  [list_bids]="opened_schedule.transaction?.waiting_bids || animal_obj.bids"
  [increment]="opened_schedule.increment || animal_obj.attual_increment || 20"
  [attual_bid]="attual_bid || 20"
  [next_bid]="next_bid || 20"
  [isStatus]="isStatus"
  (eventSocket)="eventSocket($event)"
></app-online-bid-action>

<!--*     PRE LANCE -->
<app-pre-bid-action
  *ngIf="
    loading === 0 &&
    bid_type === 'PRELANCE' &&
    opened_schedule.enable_site_pre_bid
  "
  [animal_obj]="animal_obj"
  [auction_bid]="animal_obj?.auction_bid"
  [opened_schedule]="opened_schedule"
  [is_live]="is_live"
  [list_bids]="animal_obj?.bids"
  [increment]="animal_obj.attual_increment || 20"
  [attual_bid]="attual_bid || 20"
  [next_bid]="next_bid || 20"
  [isStatus]="isStatus"
  (eventSocket)="eventSocket($event)"
></app-pre-bid-action>

<!--TODO    SHOPPING -->
<app-purchase-action
  *ngIf="loading === 0 && bid_type === 'SHOPPING'"
  [animal_obj]="animal_obj"
  [auction_bid]="animal_obj?.auction_bid"
  [opened_schedule]="opened_schedule"
  [increment]="opened_schedule.increment || 20"
  (eventSocket)="eventSocket($event)"
></app-purchase-action>
